
import { createSlice } from '@reduxjs/toolkit';


const modalSlice = createSlice({
    name: 'modal',
    initialState: {
        showFormModal: false,
        componentName: null,
        showOTPModal: false,
        otpTnxRedirect: false
    },
    reducers: {
        openFormModal: (state, action) => {
            state.showFormModal = true;
            state.componentName = action.payload;
        },
        closeFormModal: (state) => {
            state.showFormModal = false;

        },
        openOTPModal: (state, action) => {
            state.showOTPModal = true;
            state.otpTnxRedirect = action.payload?.tnxRedirect || false;
        },
        closeOTPModal: (state) => {
            state.showOTPModal = false;
            state.otpTnxRedirect = false;
        }
    }
});

export const { openFormModal, closeFormModal, openOTPModal, closeOTPModal } = modalSlice.actions;
export default modalSlice.reducer;